var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.645 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.645L5.343 7 0 12.355 1.645 14l7-7-7-7z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "chevron-right-07c634cda3d4efe11cdbaf3aa05807ac.svg";
export { SvgChevronRight as ReactComponent };